(() => {
	const CHANNEL_NAME = 'csrf-sync';
	const STORAGE_KEY = 'csrf-token';
	const FORM_SELECTOR = 'form[data-csrf-sync]';
	const TOKEN_INPUT_SELECTOR = 'input[name="_csrf"]';
	const CHECK_INTERVAL_MS = 5000;

	let currentToken = window._csrf;
	let channel;

	init();

	function init() {
		// Store initial token in sessionStorage
		if (currentToken) {
			sessionStorage.setItem(STORAGE_KEY, currentToken);
		}

		// Open one channel for both send & receive
		channel = new BroadcastChannel(CHANNEL_NAME);
		channel.onmessage = handleIncomingMessage;

		// Watch for token changes periodically
		setInterval(checkForTokenChange, CHECK_INTERVAL_MS);

		// Watch for dynamically added forms
		observeFormChanges();

		// Initial form update
		updateForms(currentToken);

		// If there is a token, broadcast it to other tabs/windows
		if (currentToken) {
			channel.postMessage(currentToken);
		}
	}

	function handleIncomingMessage(event) {
		const newToken = event.data;
		if (typeof newToken !== 'string' || !newToken.trim()) {
			return;
		}

		if (newToken !== currentToken) {
			currentToken = newToken;
			sessionStorage.setItem(STORAGE_KEY, newToken);
			updateForms(newToken);
		}
	}

	function checkForTokenChange() {
		const latestCookieToken = window._csrf;
		if (latestCookieToken && latestCookieToken !== currentToken) {
			currentToken = latestCookieToken;
			sessionStorage.setItem(STORAGE_KEY, latestCookieToken);
			updateForms(latestCookieToken);
			channel.postMessage(latestCookieToken);
		}
	}

	function updateForms(token) {
		if (!token) {
			return;
		}

		document.querySelectorAll(FORM_SELECTOR).forEach((form) => {
			let input = form.querySelector(TOKEN_INPUT_SELECTOR);
			if (!input) {
				input = document.createElement('input');
				input.type = 'hidden';
				input.name = '_csrf';
				form.appendChild(input);
			}
			input.value = token;
		});
	}

	function observeFormChanges() {
		const observer = new MutationObserver((mutations) => {
			for (const mutation of mutations) {
				mutation.addedNodes.forEach((node) => {
					if (node.nodeType === Node.ELEMENT_NODE) {
						if (node.matches && node.matches(FORM_SELECTOR)) {
							updateForms(currentToken);
						} else if (node.querySelectorAll) {
							node.querySelectorAll(FORM_SELECTOR).forEach(() => {
								updateForms(currentToken);
							});
						}
					}
				});
			}
		});
		observer.observe(document.body, { childList: true, subtree: true });
	}
})();
